module.exports = __webpack_public_path__ + "img/edit-icon.f4eff09d.svg";